class OverlayBackground extends HTMLElement {
  constructor() {
    super();
    this.context = this.getAttribute('for');
    this.delay = this.getAttribute('data-delay') ? this.getAttribute('data-delay') : 0;

    window.addEventListener('init-overlay', (e) => {
      const overlayModal = document.querySelector(`[data-label="${e.detail}"] > .overlay__modal`);
      if (e.detail == this.context) {
        overlayModal.style.zIndex = parseInt(this.dataset.z_index) + 1;
        setTimeout(() => {
          document.querySelector(`[data-label="${e.detail}"] > .overlay__modal`).setAttribute('data-open', true);
        }, this.delay);
        this.initOverlayBackground();
      }
    });
    window.addEventListener('close-overlay', (e) => {
      const overlayModal = document.querySelector(`[data-label="${e.detail}"] > .overlay__modal`);
      if (e.detail == this.context) {
        overlayModal.setAttribute('data-open', false);
        setTimeout(() => {
          this.closeOverlayBackground();
        }, this.delay);
      }
    });
  }
  initOverlayBackground() {
    this.style.display = 'block';
    this.style.opacity = this.dataset.opacity ? this.dataset.opacity : '.3';
    this.style.zIndex = this.dataset.z_index ? this.dataset.z_index : '2';
    let scrolledPosition = window.scrollY;
    if (this.dataset.scroll == 'false') {
      if (window.location.pathname.includes('/collections') || window.location.pathname.includes('/search')) {
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
      } else {
        //locks the screen in the current position when overlay is active, while still disabling scroll
        document.body.setAttribute('data-scrollable', false);
        if (scrolledPosition && scrolledPosition > 0) {
          document.body.style.top = `${scrolledPosition * -1}px`;
        }

        setTimeout(() => {
          document.documentElement.classList.add('overlay-active');
        }, 0);
      }
    }
  }

  closeOverlayBackground() {
    //prevents the jumping behavior when closing overlay by forcing a scroll to the previous position of the page
    this.style.display = 'none';
    if (window.location.pathname.includes('/collections') || window.location.pathname.includes('/search')) {
      document.body.classList.remove('overflow-hidden');
      setTimeout(() => {
        document.documentElement.classList.remove('overflow-hidden');
      }, 100);
    } else {
      let previousPosition = parseInt(document.body.style.top.replace('px', '')) * -1;
      document.body.removeAttribute('data-scrollable');
      window.scrollTo(0, previousPosition);
      setTimeout(() => {
        document.documentElement.classList.remove('overlay-active');
        document.querySelector('#shopify-section-header').style.top = `-${document.querySelector('nano-bar').offsetHeight || document.querySelector('.nano--container').offsetHeight}px`;
        document.body.style.top = '';
      }, 100);
    }
  }
}

customElements.define('overlay-background', OverlayBackground);

/***
 CONTENT DRAWER (Slides in from the right on PDP)
 ***/

class ContentDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector('overlay-background').addEventListener('click', () => {
      this.closeOverlay();
    });
    this.querySelector('.icon-close').addEventListener('click', () => {
      this.closeOverlay();
    });
  }
  closeOverlay() {
    const closeOverlayBackground = new CustomEvent('close-overlay', {
      detail: this.getAttribute('data-label'),
    });
    window.dispatchEvent(closeOverlayBackground);
  }
}

export default function addOverlayListeners() {
  Array.from(document.querySelectorAll('[data-type="modal"]')).forEach((el) => {
    el.addEventListener('click', () => {
      const initOverlayBackground = new CustomEvent('init-overlay', {
        detail: el.getAttribute('for'),
      });
      window.dispatchEvent(initOverlayBackground);
    });
  });
  const productHandle = document.querySelector('.js-main-product')?.getAttribute('props-handle')?.substring(1);
  Array.from(document.querySelectorAll('.modal-drawer-trigger')).forEach((el) => {
    el.setAttribute('data-type', 'modal');
    el.setAttribute('for', `${el.getAttribute('data-content')}-${productHandle || ''}`);
    el.addEventListener('click', () => {
      const initOverlayBackground = new CustomEvent('init-overlay', {
        detail: el.getAttribute('for'),
      });
      window.dispatchEvent(initOverlayBackground);
    });
  });
}

document.addEventListener('theme:overlay:refresh', addOverlayListeners);
customElements.define('content-drawer', ContentDrawer);
